import ScenarioDisplayProps from "./ScenarioDisplayProps";

export function getFuturePeriodText(props: ScenarioDisplayProps) {
  switch (props.futurePeriod) {
    case "Y/E":
      return "at Year-End";
    case "1 Yr":
      return "in 1 Year";
    case "2 Yr":
      return "in 2 Years";
    case "Max":
      return "";
    default:
      return "";
  }
}
